export default {
  ['videos']: state => state.videos,
  ['filteredVideos']: state => state.filteredVideos,
  ['allVideosLoaded']: state => state.allVideosLoaded,
  ['totalVideos']: state => state.totalVideos,
  ['currentFolderId']: state => state.currentFolderId,
  ['selectedVideos']: state => state.selectedVideos
}
